import React from 'react';
import { Box, Tooltip } from '@mui/material';
import ShortTextIcon from '@mui/icons-material/ShortText';
import NotesIcon from '@mui/icons-material/Notes';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ListIcon from '@mui/icons-material/List';
import { QuestionType } from '../../types/ApplicationQuestion';

interface QuestionTypePillProps {
    type: QuestionType;
    size?: 'small' | 'medium';
}

const QuestionTypePill: React.FC<QuestionTypePillProps> = ({ type, size = 'small' }) => {
    const getIcon = () => {
        switch (type) {
            case QuestionType.SHORT_ANSWER:
                return <ShortTextIcon fontSize={size} />;
            case QuestionType.PARAGRAPH:
                return <NotesIcon fontSize={size} />;
            case QuestionType.MULTIPLE_CHOICE:
                return <CheckBoxIcon fontSize={size} />;
            case QuestionType.SINGLE_CHOICE:
                return <RadioButtonCheckedIcon fontSize={size} />;
            case QuestionType.DROPDOWN:
                return <ListIcon fontSize={size} />;
            case QuestionType.MULTIPLE_CHOICE_GRID:
                return <CheckBoxIcon fontSize={size} />;
            case QuestionType.SINGLE_CHOICE_GRID:
                return <RadioButtonCheckedIcon fontSize={size} />;
            case QuestionType.SECTION:
                return <ListIcon fontSize={size} />;
            default:
                return null;
        }
    };

    const getLabel = () => {
        switch (type) {
            case QuestionType.SHORT_ANSWER:
                return 'Short Answer';
            case QuestionType.PARAGRAPH:
                return 'Paragraph';
            case QuestionType.MULTIPLE_CHOICE:
                return 'Multiple Choice';
            case QuestionType.SINGLE_CHOICE:
                return 'Single Choice';
            case QuestionType.DROPDOWN:
                return 'Dropdown';
            case QuestionType.MULTIPLE_CHOICE_GRID:
                return 'Multiple Choice Grid';
            case QuestionType.SINGLE_CHOICE_GRID:
                return 'Single Choice Grid';
            case QuestionType.SECTION:
                return 'Section';
            default:
                return '';
        }
    };

    return (
        <Tooltip title={getLabel()}>
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: 'text.secondary',
                    '& svg': {
                        fontSize: size === 'small' ? '1rem' : '1.25rem'
                    }
                }}
            >
                {getIcon()}
            </Box>
        </Tooltip>
    );
};

export default QuestionTypePill;
